import { Language } from '../types';

export const translations = {
  EN: {
    nav: {
      product: 'Product',
      pricing: 'Pricing',
      enterprise: 'Enterprise',
      login: 'Log in',
      getStarted: 'Get Started'
    },
    hero: {
      new: 'New: AI Financial Assistant',
      titleStart: 'Banking built for',
      titleEnd: 'Global Merchants',
      desc: 'Send invoices, receive payments, and manage multi-currency cash flow with the speed of a fintech and the security of a bank.',
      openAccount: 'Open Account',
      contactSales: 'Contact Sales',
      noFees: 'No hidden fees',
      instant: 'Instant transfers',
      fdic: 'FDIC Insured'
    },
    features: {
      title: 'Everything you need to grow globally',
      subtitle: 'Stop worrying about exchange rates and slow transfers. Focus on your product.',
      f1_title: 'Multi-Currency Accounts',
      f1_desc: 'Hold, convert, and send money in over 50 currencies with the real exchange rate.',
      f2_title: 'Fraud Protection',
      f2_desc: 'Advanced AI monitoring keeps your transactions safe without slowing you down.',
      f3_title: 'Instant Payouts',
      f3_desc: 'Get paid by marketplaces and withdraw to your local bank account in seconds.'
    },
    product: {
      title: 'Global Financial Tools',
      subtitle: 'One platform to manage all your business finance needs.',
      f1_title: 'Global Accounts',
      f1_desc: 'Get local account details in 10 currencies to get paid like a local.',
      f2_title: 'Corporate Cards',
      f2_desc: 'Issue physical and virtual cards for your team with spending limits.',
      f3_title: 'Spend Management',
      f3_desc: 'Track expenses in real-time and automate your bookkeeping.'
    },
    pricing: {
      title: 'Simple, transparent pricing',
      subtitle: 'Choose the plan that fits your business stage.',
      free: 'Starter',
      pro: 'Growth',
      ent: 'Enterprise',
      free_price: '$0',
      pro_price: '$15',
      ent_price: 'Custom',
      mo: '/mo',
      perks_free: ['US & EUR Accounts', '2 Virtual Cards', 'Basic Support'],
      perks_pro: ['10+ Currencies', 'Unlimited Cards', 'Priority Support', 'AI Assistant'],
      perks_ent: ['Custom Integration', 'Dedicated Manager', 'Volume Discounts', 'API Access']
    },
    enterprise: {
      title: 'Scale your payments globally',
      subtitle: 'Custom solutions for high-volume marketplaces and platforms.',
      contact: 'Contact our sales team for a custom demo.',
      cta: 'Talk to Sales'
    },
    auth: {
      login_title: 'Welcome back',
      login_subtitle: 'Enter your credentials to access your account.',
      signup_title: 'Create your account',
      signup_subtitle: 'Start banking globally in minutes.',
      email: 'Email address',
      password: 'Password',
      name: 'Full Name',
      submit_login: 'Sign In',
      submit_signup: 'Create Account',
      or: 'or',
      google: 'Continue with Google'
    },
    dashboard: {
      nav: {
        home: 'Home',
        transactions: 'Transactions',
        cards: 'Cards',
        ai: 'BancoBot AI',
        signout: 'Sign Out'
      },
      header: {
        search: 'Search transactions...',
        pro: 'Pro Account'
      },
      home: {
        greeting: 'Good morning',
        subtitle: "Here's what's happening with your business today.",
        statement: 'Statement',
        addMoney: 'Add Money',
        sendFunds: 'Send Funds',
        thisWeek: 'this week',
        stable: 'Stable',
        openBalance: 'Open Balance',
        moreCurrencies: '50+ currencies available',
        cashFlow: 'Cash Flow',
        recentActivity: 'Recent Activity',
        viewAll: 'View All',
        viewReport: 'View detailed report'
      },
      transactions: {
        title: 'All Transactions',
        filter: 'Filter',
        export: 'Export CSV',
        cols: {
          merchant: 'Merchant/Description',
          date: 'Date',
          status: 'Status',
          amount: 'Amount'
        }
      }
    }
  },
  FR: {
    nav: {
      product: 'Produit',
      pricing: 'Tarifs',
      enterprise: 'Entreprise',
      login: 'Connexion',
      getStarted: 'Commencer'
    },
    hero: {
      new: 'Nouveau : Assistant Financier IA',
      titleStart: 'La banque pour les',
      titleEnd: 'Marchands Mondiaux',
      desc: 'Envoyez des factures, recevez des paiements et gérez votre trésorerie multidevise avec la rapidité d\'une fintech et la sécurité d\'une banque.',
      openAccount: 'Ouvrir un compte',
      contactSales: 'Contacter les ventes',
      noFees: 'Pas de frais cachés',
      instant: 'Virements instantanés',
      fdic: 'Assuré FDIC'
    },
    features: {
      title: 'Tout ce dont vous avez besoin pour grandir mondialement',
      subtitle: 'Ne vous souciez plus des taux de change et des transferts lents. Concentrez-vous sur votre produit.',
      f1_title: 'Comptes Multi-Devises',
      f1_desc: "Détenez, convertissez et envoyez de l'argent dans plus de 50 devises au taux de change réel.",
      f2_title: 'Protection contre la fraude',
      f2_desc: 'La surveillance IA avancée protège vos transactions sans vous ralentir.',
      f3_title: 'Paiements Instantanés',
      f3_desc: 'Faites-vous payer par les places de marché et retirez sur votre compte bancaire local en quelques secondes.'
    },
    product: {
      title: 'Outils Financiers Mondiaux',
      subtitle: 'Une plateforme unique pour gérer tous vos besoins financiers.',
      f1_title: 'Comptes Mondiaux',
      f1_desc: 'Obtenez des coordonnées bancaires locales dans 10 devises.',
      f2_title: 'Cartes Corporate',
      f2_desc: 'Émettez des cartes physiques et virtuelles pour votre équipe.',
      f3_title: 'Gestion des Dépenses',
      f3_desc: 'Suivez les dépenses en temps réel et automatisez la comptabilité.'
    },
    pricing: {
      title: 'Tarification simple et transparente',
      subtitle: 'Choisissez le plan adapté à votre stade de développement.',
      free: 'Démarrage',
      pro: 'Croissance',
      ent: 'Entreprise',
      free_price: '0€',
      pro_price: '15€',
      ent_price: 'Sur mesure',
      mo: '/mois',
      perks_free: ['Comptes US & EUR', '2 Cartes Virtuelles', 'Support de base'],
      perks_pro: ['10+ Devises', 'Cartes Illimitées', 'Support Prioritaire', 'Assistant IA'],
      perks_ent: ['Intégration Personnalisée', 'Manager Dédié', 'Remises sur Volume', 'Accès API']
    },
    enterprise: {
      title: 'Échellez vos paiements mondialement',
      subtitle: 'Solutions personnalisées pour les places de marché à fort volume.',
      contact: 'Contactez notre équipe commerciale pour une démo.',
      cta: 'Parler aux ventes'
    },
    auth: {
      login_title: 'Bon retour',
      login_subtitle: 'Entrez vos identifiants pour accéder à votre compte.',
      signup_title: 'Créez votre compte',
      signup_subtitle: 'Commencez à banquer mondialement en quelques minutes.',
      email: 'Adresse e-mail',
      password: 'Mot de passe',
      name: 'Nom complet',
      submit_login: 'Se connecter',
      submit_signup: 'Créer un compte',
      or: 'ou',
      google: 'Continuer avec Google'
    },
    dashboard: {
      nav: {
        home: 'Accueil',
        transactions: 'Transactions',
        cards: 'Cartes',
        ai: 'BancoBot IA',
        signout: 'Déconnexion'
      },
      header: {
        search: 'Rechercher...',
        pro: 'Compte Pro'
      },
      home: {
        greeting: 'Bonjour',
        subtitle: 'Voici la situation de votre entreprise aujourd\'hui.',
        statement: 'Relevé',
        addMoney: 'Ajouter',
        sendFunds: 'Envoyer',
        thisWeek: 'cette semaine',
        stable: 'Stable',
        openBalance: 'Ouvrir Solde',
        moreCurrencies: '50+ devises disponibles',
        cashFlow: 'Flux de trésorerie',
        recentActivity: 'Activité récente',
        viewAll: 'Voir tout',
        viewReport: 'Voir le rapport détaillé'
      },
      transactions: {
        title: 'Toutes les transactions',
        filter: 'Filtrer',
        export: 'Exporter CSV',
        cols: {
          merchant: 'Marchand/Description',
          date: 'Date',
          status: 'Statut',
          amount: 'Montant'
        }
      }
    }
  },
  ES: {
    nav: {
      product: 'Producto',
      pricing: 'Precios',
      enterprise: 'Empresas',
      login: 'Entrar',
      getStarted: 'Empezar'
    },
    hero: {
      new: 'Nuevo: Asistente Financiero IA',
      titleStart: 'Banca para',
      titleEnd: 'Comerciantes Globales',
      desc: 'Envía facturas, recibe pagos y gestiona el flujo de caja multidivisa con la velocidad de una fintech y la seguridad de un banco.',
      openAccount: 'Abrir Cuenta',
      contactSales: 'Contactar Ventas',
      noFees: 'Sin comisiones ocultas',
      instant: 'Transferencias al instante',
      fdic: 'Asegurado por FDIC'
    },
    features: {
      title: 'Todo lo que necesitas para crecer globalmente',
      subtitle: 'Deja de preocuparte por los tipos de cambio y las transferencias lentas. Céntrate en tu producto.',
      f1_title: 'Cuentas Multidivisa',
      f1_desc: 'Mantén, convierte y envía dinero en más de 50 divisas con el tipo de cambio real.',
      f2_title: 'Protección contra Fraude',
      f2_desc: 'La monitorización avanzada con IA mantiene tus transacciones seguras sin ralentizarte.',
      f3_title: 'Pagos Instantáneos',
      f3_desc: 'Cobra de marketplaces y retira a tu cuenta bancaria local en segundos.'
    },
    product: {
      title: 'Herramientas Financieras Globales',
      subtitle: 'Una plataforma para gestionar todas tus finanzas.',
      f1_title: 'Cuentas Globales',
      f1_desc: 'Obtén datos bancarios locales en 10 divisas para cobrar como local.',
      f2_title: 'Tarjetas Corporativas',
      f2_desc: 'Emite tarjetas físicas y virtuales para tu equipo con límites.',
      f3_title: 'Gestión de Gastos',
      f3_desc: 'Sigue los gastos en tiempo real y automatiza tu contabilidad.'
    },
    pricing: {
      title: 'Precios simples y transparentes',
      subtitle: 'Elige el plan que se adapte a tu etapa de negocio.',
      free: 'Inicial',
      pro: 'Crecimiento',
      ent: 'Empresas',
      free_price: '0€',
      pro_price: '15€',
      ent_price: 'A medida',
      mo: '/mes',
      perks_free: ['Cuentas en US & EUR', '2 Tarjetas Virtuales', 'Soporte Básico'],
      perks_pro: ['10+ Divisas', 'Tarjetas Ilimitadas', 'Soporte Prioritario', 'Asistente IA'],
      perks_ent: ['Integración a Medida', 'Gestor Dedicado', 'Descuentos por Volumen', 'Acceso API']
    },
    enterprise: {
      title: 'Escala tus pagos globalmente',
      subtitle: 'Soluciones personalizadas para marketplaces y plataformas de alto volumen.',
      contact: 'Contacta con nuestro equipo para una demo.',
      cta: 'Hablar con Ventas'
    },
    auth: {
      login_title: 'Bienvenido de nuevo',
      login_subtitle: 'Introduce tus credenciales para acceder.',
      signup_title: 'Crea tu cuenta',
      signup_subtitle: 'Empieza a operar globalmente en minutos.',
      email: 'Correo electrónico',
      password: 'Contraseña',
      name: 'Nombre completo',
      submit_login: 'Iniciar Sesión',
      submit_signup: 'Crear Cuenta',
      or: 'o',
      google: 'Continuar con Google'
    },
    dashboard: {
      nav: {
        home: 'Inicio',
        transactions: 'Movimientos',
        cards: 'Tarjetas',
        ai: 'BancoBot IA',
        signout: 'Cerrar Sesión'
      },
      header: {
        search: 'Buscar movimientos...',
        pro: 'Cuenta Pro'
      },
      home: {
        greeting: 'Buenos días',
        subtitle: 'Esto es lo que pasa en tu negocio hoy.',
        statement: 'Extracto',
        addMoney: 'Añadir',
        sendFunds: 'Enviar',
        thisWeek: 'esta semana',
        stable: 'Estable',
        openBalance: 'Abrir Balance',
        moreCurrencies: '50+ divisas disponibles',
        cashFlow: 'Flujo de Caja',
        recentActivity: 'Actividad Reciente',
        viewAll: 'Ver todo',
        viewReport: 'Ver informe detallado'
      },
      transactions: {
        title: 'Todas las transacciones',
        filter: 'Filtrar',
        export: 'Exportar CSV',
        cols: {
          merchant: 'Comercio/Descripción',
          date: 'Fecha',
          status: 'Estado',
          amount: 'Cantidad'
        }
      }
    }
  }
};